// 9fbef606107a605d69c0edbcd8029e5d
import FAVORITES_CONSTANTS from './Favorites.constants';

export const addItemsToWishlist = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.SET_FAVORITES,
    payload,
  };
};

export const setWishlistState = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.SET_FAVORITES_STATE,
    payload,
  };
};

export const getUserFavt = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.GET_USER_FAVORITES,
    payload,
  };
};

export const setAddToFavoriteErrorState = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.SET_FAVORITES_ERROR,
    payload,
  };
};

export const removeAddToFavoriteErrorState = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.REMOVE_FAVORITES_ERROR,
    payload,
  };
};

export const getSetWishlistsSummariesAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.GET_FAVORITES_WISHLIST,
    payload,
  };
};

export const setActiveWishlistAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.SET_ACTIVE_WISHLIST,
    payload,
  };
};

export function getSetDefaultWishListActn(wishList) {
  return {
    payload: wishList,
    type: FAVORITES_CONSTANTS.FAVORITES_SET_DEFAULT_WISHLIST,
  };
}

export const getActiveWishlistAction = (wishListId, wishListName, isSBP = false) => {
  return {
    type: FAVORITES_CONSTANTS.LOAD_ACTIVE_FAVORITES_WISHLIST,
    wishListId,
    wishListName,
    isSBP,
  };
};

export const getActiveWishlistGuestAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.LOAD_ACTIVE_FAVORITES_WISHLIST_GUEST,
    payload,
  };
};

export const createNewWishListAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.CREATE_NEW_WISHLIST,
    payload,
  };
};

export const createNewWishListMoveItemAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.CREATE_NEW_WISHLIST_MOVE_ITEM,
    payload,
  };
};

export const deleteWishListAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.DELETE_WISHLIST,
    payload,
  };
};
export const deleteWishListActionOOS = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.DELETE_WISHLIST_OOS,
    payload,
  };
};

export const setLastDeletedItemIdAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.DELETE_WISHLIST_ITEM,
    payload,
  };
};

export const setReplaceWishlistItem = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.FAVORITES_REPLACE_WISHLIST_ITEM,
    payload,
  };
};

export const setDeletedItemAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.DELETED_WISHLIST_ITEM,
    payload,
  };
};

export const updateWishListAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.UPDATE_WISHLIST,
    payload,
  };
};

export const updateWishListItemIdAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.UPDATE_WISHLIST_ITEM,
    payload,
  };
};

export const sendWishListMailAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.SEND_WISHLIST_EMAIL,
    payload,
  };
};

export const setWishlistsSummariesAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.SET_FAVORITES_WISHLIST,
    payload,
  };
};

export const getSetIsWishlistReadOnlyAction = (isReadOnly) => {
  return {
    isReadOnly,
    type: FAVORITES_CONSTANTS.FAVORITES_SET_IS_READ_ONLY_WISHLIST,
  };
};

export const getSetActiveWishlistAction = (activeWishlist) => {
  return {
    activeWishlist,
    type: FAVORITES_CONSTANTS.FAVORITES_SET_ACTIVE_WISHLIST,
  };
};

export const setLoadingState = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.FAVORITES_SET_LOADING,
    payload,
  };
};

export const setWishListShareSuccess = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.FAVORITES_SET_WISHLIST_SHARE_SUCCESS,
    payload,
  };
};

export const setMaximumProductAddedErrorState = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.MAXIMUM_PRODUCT_ADDED_ERROR,
    payload,
  };
};

export const resetMaximumProductAddedErrorState = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.RESET_MAXIMUM_PRODUCT_ADDED_ERROR,
    payload,
  };
};

export const setOSSItemID = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.FAVORITES_SET_CLICKED_OOS_ITEM_ID,
    payload,
  };
};

export const setDefaultWishListIdActn = (wishList) => {
  return {
    payload: wishList,
    type: FAVORITES_CONSTANTS.FAVORITES_SET_DEFAULT_WISHLIST_ID,
  };
};

export const resetFavoritesReducer = () => {
  return {
    type: FAVORITES_CONSTANTS.RESET_FAVORITES_REDUCER,
  };
};

export const setDeleteFavItemProgress = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.SET_DELETE_FAV_ITEM_PROGRESS,
    payload,
  };
};

export const createNewWishListAddItemAction = (payload) => {
  return {
    type: FAVORITES_CONSTANTS.CREATE_NEW_WISHLIST_ADD_ITEM,
    payload,
  };
};

export const setPendingAddWishlistProduct = (payload) => {
  return {
    payload,
    type: FAVORITES_CONSTANTS.SET_PENDING_ADD_WISHLIST_PRODUCT,
  };
};

export const showToastModal = ({ duration, showToast }) => {
  return {
    type: FAVORITES_CONSTANTS.SHOW_TOAST_MODAL,
    payload: {
      duration,
      showToast,
    },
  };
};

export const setShowLoginModal = (payload) => ({
  type: FAVORITES_CONSTANTS.SET_SHOW_LOGIN_MODAL,
  payload,
});

export const showATFflyout = (payload) => ({
  type: FAVORITES_CONSTANTS.SHOW_ADD_TO_FAVORITES_FLYOUT,
  payload,
});

export const setPreservedDefaultWishList = (payload) => ({
  type: FAVORITES_CONSTANTS.SET_PRESERVED_DEFAULT_WISHLIST,
  payload,
});

export const clearPreservedDefaultWishList = () => ({
  type: FAVORITES_CONSTANTS.CLEAR_PRESERVED_DEFAULT_WISHLIST,
});
